import foreignSourceInfo from "../foreignSourceInfo/foreignSourceInfo.vue";
import { InfoHotelUtils, EventPopup } from "../../../mixins";

import {
  FREE,
  REQUEST,
  ONLINE,
  BASKET_TYPE_HOTEL,
  NO,
  MANUAL,
  UNIT_VOLUME_MBN,
  UNIT_VOLUME_PLA,
  UNIT_VOLUME_MAN,
  UNIT_VOLUME_SRP,
  AIS
} from "../../../util/enumTypes";

export default {
  mixins: [InfoHotelUtils, EventPopup],
  components: {
    foreignSourceInfo
  },
  props: {
    service: Object,
    index: Number,
    fromOrder: Boolean,
    isRemove: Boolean
  },
  computed: {
    maxTouristCount() {
      return this.$store.state.SettingStorage.touristCount;
    },
    servicePlace: {
      get() {
        return this.fromOrder ? this.service.quantity : this.service.place;
      },
      set(value) {
        this.fromOrder
          ? (this.service.quantity = value)
          : (this.service.place = value);
      }
    },
    serviceRooms: {
      get() {
        return this.fromOrder ? this.service.quantity : this.service.rooms;
      },
      set(value) {
        this.fromOrder
          ? (this.service.quantity = value)
          : (this.service.rooms = value);
      }
    },
    specialManualText() {
      // Показ дополнительно текста в наименовании, если ручное специальное предложение
      return this.service.special == MANUAL
        ? this.$t("search_form_special_manual")
        : "";
    },
    isServicePerPlace() {
      // Услуга оказывается за место, а не номер
      return (
        this.service.unitOfPayment == UNIT_VOLUME_MBN ||
        this.service.unitOfPayment == UNIT_VOLUME_PLA ||
        this.service.unitOfPayment == UNIT_VOLUME_MAN ||
        this.service.unitOfPayment == UNIT_VOLUME_SRP
      );
    },
    averageSum() {
      return this.service.averagePriceDisplay || this.service.price;
    },
    totalSum() {
      return (
        this.service.totalPriceDisplay ||
        this.service.price * this.service.quantity
      );
    },
    showSpecial() {
      // Показ иконки специального предложения
      return this.service.special != NO;
    },
    showForeign() {
      return this.service.source != AIS;
    },
    isOnlineSale() {
      return this.service.status == ONLINE;
    },
    isFreeSale() {
      if (this.service.status == FREE) {
        return this.showForeign || !this.service.soldOut;
      } else {
        return false;
      }
    },
    statusName() {
      return {
        [FREE]: this.$t("search_result_free"),
        [REQUEST]: this.$t("search_result_request"),
        [ONLINE]: this.$t("search_result_online")
      };
    },
    getStatus() {
      let status = this.getStatusServiceMixins(this.service);
      return this.statusName[status] || "";
    },
    disabledAddBasket() {
      return (
        this.showForeign &&
        (this.service.soldOut || this.service.soldOutUndefined)
      );
    }
  },
  data: function () {
    return {
      popperOptions: {
        boundariesElement: "body",
        gpuAcceleration: true,
        positionFixed: true,
        preventOverflow: true
      },
      placeIcon: {
        1: "/images/i-user-one.png",
        2: "/images/i-user-two.png",
        3: "/images/i-user-multy.png"
      },
      defaultPlaceIcon: 1,
      showDelay: 500
    };
  },
  methods: {
    getPlaceIcon(place) {
      return this.placeIcon[place]
        ? this.placeIcon[place]
        : this.placeIcon[this.defaultPlaceIcon];
    },
    roomsChange() {
      this.emitEventPopup("roomsChange", {
        serviceIndex: this.index,
        rooms: this.service.rooms
      });
    },
    clickTerms() {
      this.emitEventPopup("clickTerms", {
        serviceIndex: this.index
      });
    },
    addToOrder() {
      // Добавить в заказ
      this.emitEventPopup("hotelToBasket", {
        serviceIndex: this.index,
        type: BASKET_TYPE_HOTEL,
        rooms: this.service.rooms
      });
    },
    removeFromOrder() {
      this.emitEventPopup("removeHotelFromBasket", {
        serviceGUID: this.service.guid,
        type: BASKET_TYPE_HOTEL
      });
    },
    clickShowAdditional() {
      this.emitEventPopup("showAdditionalClick", { serviceIndex: this.index });
      this.service.additionalServiceShowClick = true;
    }
  }
};
